/**
 * @owner @Appboy/frontend-ix
 * @fileoverview resolves a valid BCP 47 language tag from untrusted candidates.
 *
 * The server renders a whitelisted `<html lang>`, but browser translate
 * features and extensions rewrite `[lang]` attributes after load with values
 * like "auto" or "en-US@posix" that throw RangeError in `Intl` constructors.
 */

export const fallbackLocale = "en-US";

/**
 * Returns the first candidate that is a structurally valid BCP 47 language
 * tag, canonicalized, or fallbackLocale when none qualify.
 */
export const getSafeLocale = (...candidates: Array<string | null | undefined>): string => {
  for (const candidate of candidates) {
    if (candidate) {
      try {
        const [canonical] = Intl.getCanonicalLocales(candidate);
        if (canonical) {
          return canonical;
        }
      } catch {
        // invalid tag -- fall through to the next candidate
      }
    }
  }

  return fallbackLocale;
};
